<template>
  <div class="collapsible-panel" :class="wrapperModifier">
    <div class="collapsible-panel__header" :class="darkHeaderModifier" @click="toggle">
      <div class="collapsible-panel__header-text" v-if="hasSlotTitle">
        <slot name="title"></slot>
      </div>
      <div class="collapsible-panel__header-text" v-if="!hasSlotTitle" v-html="title"></div>
    </div>
    <div class="collapsible-panel__content" :class="noPaddingModifier" v-if="isOpenState">
      <template v-if="hasSlotContent">
        <slot></slot>
      </template>
      <template v-else>
        <div v-html="content"></div>
      </template>
    </div>
  </div>
</template>
<script src="./collapsible-panel.js"></script>
<style src="./collapsible-panel.scss" lang="scss"></style>
